/* Shopify owns consent storage and server-side form abuse protection. */
(() => {
  if (window.__ermanTrustReady) return;
  window.__ermanTrustReady = true;
  let bannerPromise;
  let opening = false;

  const loadPrivacyBanner = () => {
    if (window.privacyBanner?.showPreferences) return Promise.resolve(window.privacyBanner);
    if (bannerPromise) return bannerPromise;
    bannerPromise = new Promise((resolve, reject) => {
      const source = 'https://cdn.shopify.com/shopifycloud/privacy-banner/storefront-banner.js';
      let script = Array.from(document.scripts).find(item => item.src === source);
      const timer = setTimeout(() => finish(new Error('Privacy settings unavailable')), 8000);
      const onLoad = () => finish();
      const onError = () => finish(new Error('Privacy script unavailable'));
      function finish(error) {
        clearTimeout(timer);
        script?.removeEventListener('load', onLoad);
        script?.removeEventListener('error', onError);
        if (error || !window.privacyBanner?.showPreferences) {
          if (script?.dataset.ermanPrivacyLoader === 'true') script.remove();
          reject(error || new Error('Privacy settings unavailable'));
        } else {
          resolve(window.privacyBanner);
        }
      }
      if (!script) {
        script = document.createElement('script');
        script.src = source;
        script.async = true;
        script.dataset.ermanPrivacyLoader = 'true';
        script.addEventListener('load', onLoad, { once: true });
        script.addEventListener('error', onError, { once: true });
        document.head.append(script);
      } else {
        script.addEventListener('load', onLoad, { once: true });
        script.addEventListener('error', onError, { once: true });
      }
    }).catch(error => {
      bannerPromise = undefined;
      throw error;
    });
    return bannerPromise;
  };

  const showStatus = (trigger, text) => {
    const region = trigger.closest('[data-erman-privacy-area]');
    const message = region?.querySelector('[data-erman-cookie-status]');
    if (!message) return;
    message.textContent = text;
    message.hidden = !text;
  };

  document.addEventListener('click', async event => {
    const trigger = event.target instanceof Element ? event.target.closest('[data-erman-cookie-settings]') : null;
    if (!trigger || event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    event.preventDefault();
    if (opening) return;
    opening = true;
    trigger.setAttribute('aria-busy', 'true');
    const isEnglish = document.documentElement.lang.startsWith('en');
    showStatus(trigger, isEnglish ? 'Opening cookie settings…' : 'Cookie-Einstellungen werden geöffnet …');
    let modalTimer;
    try {
      const api = await loadPrivacyBanner();
      await Promise.race([
        Promise.resolve(api.showPreferences()),
        new Promise((_resolve, reject) => {
          modalTimer = setTimeout(() => reject(new Error('Privacy dialog unavailable')), 8000);
        })
      ]);
      showStatus(trigger, '');
    } catch (_error) {
      showStatus(trigger, isEnglish
        ? 'Cookie settings could not be opened. Please try again later or contact us using the contact link. No preference was changed.'
        : 'Die Cookie-Einstellungen konnten nicht geöffnet werden. Bitte versuche es später erneut oder nutze unseren Kontakt-Link. Es wurde keine Auswahl geändert.');
    } finally {
      clearTimeout(modalTimer);
      trigger.removeAttribute('aria-busy');
      opening = false;
    }
  });

  // A supplementary browser-side honeypot. Never substitutes for Shopify hCaptcha,
  // fakes a successful submission, or bypasses the native form submission flow.
  document.addEventListener('submit', event => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || !form.hasAttribute('data-erman-form')) return;
    const trap = form.querySelector('[data-erman-honeypot]');
    if (!trap?.value.trim()) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    const message = form.querySelector('[data-erman-form-error]');
    if (message) {
      message.hidden = false;
      message.focus();
    }
  }, true);
})();
